import React from 'react';
import EngagementBarLayout from 'components/post/EngagementBarLayout';
import { MessageCircle, Share2 as Share } from 'react-feather';
import { Button, Dropdown } from 'seedly-component-library';
import { SAVE_TYPE } from 'constants/app';
import { generateArticleLink } from 'utils/generateShareLink';
import BookmarkButton from 'components/post/BookmarkButton';
import useShareMenu from 'utils/hooks/useShareMenu';
import mixpanel, { trackedEvents } from 'utils/mixpanel';
import styled from 'styled-components';

const StyledMessageCircle = styled(MessageCircle)`
  margin-right: ${props => props.theme.spacing.xs};
`;

interface OwnProps {
  articleSlug: string;
  // article Id from wordpress
  articleId: number;
  commentsCount: number;
}

const ArticleEngagement = (props: OwnProps) => {
  const { articleSlug, articleId, commentsCount } = props;
  const shareUrl = generateArticleLink(articleSlug);
  const shareMenu = useShareMenu(shareUrl);

  return (
    <EngagementBarLayout
      commentsCount={commentsCount}
      commentButton={<StyledMessageCircle size={20} />}
      shareButton={
        <Dropdown
          items={shareMenu}
          handleSelectedItemchange={item => {
            item.selectedItem.onClick();
          }}
          menuAlign="left"
          button={
            <Button
              size="md"
              variant="ghost"
              data-testid="button-share-options"
              onClick={() => {
                mixpanel.track(trackedEvents.CommentThread, {
                  param: 'share',
                  category: 'article',
                });
              }}
              icon={<Share />}
            />
          }
        />
      }
      bookmarkButton={
        <BookmarkButton
          contentId={articleId}
          slug={articleSlug}
          type={SAVE_TYPE.ARTICLE}
          onClickTrack={() => {
            mixpanel.track(trackedEvents.CommentThread, {
              param: 'bookmark',
              category: 'article',
            });
          }}
        />
      }
    />
  );
};

export default ArticleEngagement;
